/**
 * Coldest PDP Gallery — Self-contained (CSS + JS)
 * Shows: sliding thumbnail gallery below main image on left.
 * Slide 1 = current variant's featured image (swaps on variant change).
 * Slides 2–6 = shared secondary images (same across all variants).
 * Total: 6 thumbnails per variant view; desktop shows 5 at a time so the
 * arrows have something to slide to (5 slides / 5 visible left them dead).
 */
(function () {
  'use strict';

  /* Guard against this exact file loading multiple times */
  if (window.__coldestPDPGalleryV2) return;
  window.__coldestPDPGalleryV2 = true;

  /* ---- Inject CSS ---- */
  var CSS = [
    '.coldest-secondary-gallery { position:relative; overflow:hidden; box-sizing:border-box; margin-top:12px; display:block !important; }',
    '.product-detail .gallery > .coldest-secondary-gallery { display:block !important; }',
    /* Inside .gallery__inner: its flex gap spaces the rail, and carousel-beside
       gives .main-image order:1 at 1041px+, which would put the rail above it. */
    '.gallery__inner > .coldest-secondary-gallery { margin-top:0; order:2; }',
    '.coldest-secondary-gallery__track-wrapper { overflow:hidden; position:relative; border-radius:6px; }',
    '.coldest-secondary-gallery__track { display:flex; gap:8px; transition:transform 0.35s cubic-bezier(0.25,0.1,0.25,1); will-change:transform; }',
    '.coldest-secondary-gallery__slide { flex:0 0 auto; cursor:pointer; border-radius:6px; overflow:hidden; border:2px solid transparent; transition:border-color 0.2s ease, opacity 0.2s ease; background:#f5f5f5; }',
    '.coldest-secondary-gallery__slide:hover { border-color:rgba(0,0,0,0.3); }',
    '.coldest-secondary-gallery__slide.is-active { border-color:#222; }',
    '.coldest-secondary-gallery__slide img { width:100%; height:100%; object-fit:cover; display:block; }',
    '.coldest-secondary-gallery__arrow { position:absolute; top:50%; transform:translateY(-50%); z-index:5; width:32px; height:32px; border-radius:50%; background:rgba(0,0,0,0.65); border:1px solid rgba(255,255,255,0.15); color:#fff; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:background 0.2s ease; padding:0; -webkit-appearance:none; appearance:none; }',
    '.coldest-secondary-gallery__arrow:hover { background:rgba(0,0,0,0.85); }',
    '.coldest-secondary-gallery__arrow--prev { left:4px; }',
    '.coldest-secondary-gallery__arrow--next { right:4px; }',
    '.coldest-secondary-gallery__arrow[disabled] { opacity:0.25; pointer-events:none; }',
    '.coldest-secondary-gallery__arrow[hidden] { display:none !important; }',
    '.coldest-secondary-gallery__arrow svg { width:16px; height:16px; fill:none; stroke:currentColor; stroke-width:2; stroke-linecap:round; stroke-linejoin:round; }'
  ].join('\n');

  var styleEl = document.createElement('style');
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  /* ---- Config ---- */
  var MAX_SLIDES      = 6;  /* must exceed VISIBLE_DESKTOP or the arrows can never move */
  var VISIBLE_DESKTOP = 5;
  var VISIBLE_MOBILE  = 4;
  var VISIBLE_SMALL   = 3;
  var GAP             = 8;

  function getVisibleCount() {
    var w = window.innerWidth;
    if (w <= 479) return VISIBLE_SMALL;
    if (w <= 767) return VISIBLE_MOBILE;
    return VISIBLE_DESKTOP;
  }

  /* ---- Helper: build thumbnail src from a base Shopify image URL ---- */
  function makeThumbSrc(srcBase) {
    if (!srcBase) return '';
    if (srcBase.indexOf('//') === 0) srcBase = 'https:' + srcBase;
    return srcBase.indexOf('?') > -1
      ? srcBase + '&width=200&height=200&crop=center'
      : srcBase + '?width=200&height=200&crop=center';
  }

  /* ---- Helper: get base src from a media object ---- */
  function getMediaSrc(m) {
    var src = m.src || (m.preview_image ? m.preview_image.src : '');
    if (src && src.indexOf('//') === 0) src = 'https:' + src;
    return src;
  }

  /* ---- Build gallery DOM (empty track — slides added dynamically) ---- */
  function buildGalleryShell() {
    var wrapper = document.createElement('div');
    wrapper.className = 'coldest-secondary-gallery pmslider-mount';

    var trackWrap = document.createElement('div');
    trackWrap.className = 'coldest-secondary-gallery__track-wrapper';

    var track = document.createElement('div');
    track.className = 'coldest-secondary-gallery__track';

    trackWrap.appendChild(track);
    wrapper.appendChild(trackWrap);

    var arrowLeft = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    var arrowRight = '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    var prevBtn = document.createElement('button');
    prevBtn.className = 'coldest-secondary-gallery__arrow coldest-secondary-gallery__arrow--prev';
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous images');
    prevBtn.innerHTML = arrowLeft;

    var nextBtn = document.createElement('button');
    nextBtn.className = 'coldest-secondary-gallery__arrow coldest-secondary-gallery__arrow--next';
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next images');
    nextBtn.innerHTML = arrowRight;

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    return wrapper;
  }

  /* ---- Create a single slide element ---- */
  function createSlide(mediaId, thumbSrc, alt) {
    var slide = document.createElement('div');
    slide.className = 'coldest-secondary-gallery__slide';
    slide.setAttribute('data-media-id', mediaId);

    var img = document.createElement('img');
    img.src = thumbSrc;
    img.alt = alt || '';
    img.loading = 'lazy';
    img.width = 200;
    img.height = 200;
    img.decoding = 'async';

    slide.appendChild(img);
    return slide;
  }

  /* ---- Size slides based on container pixel width ---- */
  function sizeSlides(gallery) {
    var containerWidth = gallery.offsetWidth;
    if (!containerWidth) return;
    var visible = getVisibleCount();
    var totalGap = GAP * (visible - 1);
    var slideW = Math.floor((containerWidth - totalGap) / visible);
    var slides = gallery.querySelectorAll('.coldest-secondary-gallery__slide');
    slides.forEach(function (s) {
      s.style.width = slideW + 'px';
      s.style.height = slideW + 'px';
    });
  }

  /* ---- Slider controller ---- */
  function initSlider(gallery) {
    var track = gallery.querySelector('.coldest-secondary-gallery__track');
    var prevBtn = gallery.querySelector('.coldest-secondary-gallery__arrow--prev');
    var nextBtn = gallery.querySelector('.coldest-secondary-gallery__arrow--next');
    var currentOffset = 0;

    function getSlideCount() {
      return track.querySelectorAll('.coldest-secondary-gallery__slide').length;
    }

    function getSlideWidth() {
      var first = track.querySelector('.coldest-secondary-gallery__slide');
      return first ? first.offsetWidth + GAP : 0;
    }

    function getMaxOffset() {
      return Math.max(0, getSlideCount() - getVisibleCount());
    }

    function updatePosition(animate) {
      var sw = getSlideWidth();
      var tx = -(currentOffset * sw);
      if (animate === false) {
        track.style.transition = 'none';
        track.offsetHeight; /* force reflow */
      } else {
        track.style.transition = 'transform 0.35s cubic-bezier(0.25,0.1,0.25,1)';
      }
      track.style.transform = 'translateX(' + tx + 'px)';
      var maxOffset = getMaxOffset();
      prevBtn.disabled = currentOffset <= 0;
      nextBtn.disabled = currentOffset >= maxOffset;
      /* No overflow (slides <= visible): the arrows can never move, so hide
         them instead of showing two permanently-dimmed buttons. */
      prevBtn.hidden = maxOffset === 0;
      nextBtn.hidden = maxOffset === 0;
    }

    prevBtn.addEventListener('click', function () {
      if (currentOffset > 0) { currentOffset--; updatePosition(true); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentOffset < getMaxOffset()) { currentOffset++; updatePosition(true); }
    });

    /* Touch / swipe */
    var touchStartX = 0, touchDelta = 0, isSwiping = false;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX; isSwiping = true; touchDelta = 0;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!isSwiping) return;
      touchDelta = e.touches[0].clientX - touchStartX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!isSwiping) return;
      isSwiping = false;
      if (touchDelta < -40 && currentOffset < getMaxOffset()) { currentOffset++; updatePosition(true); }
      else if (touchDelta > 40 && currentOffset > 0) { currentOffset--; updatePosition(true); }
    });

    /* Resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        sizeSlides(gallery);
        if (currentOffset > getMaxOffset()) currentOffset = getMaxOffset();
        updatePosition(false);
      }, 150);
    });

    /* Expose a reset function for variant changes */
    gallery.__resetSlider = function () {
      currentOffset = 0;
      sizeSlides(gallery);
      updatePosition(false);
    };

    /* Initial sizing + position */
    sizeSlides(gallery);
    updatePosition(false);
  }

  /* ---- Helper: build Shopify srcset from a base image URL ---- */
  function buildSrcset(baseSrc) {
    var clean = baseSrc.replace(/_\d+x(\.\w+)/, '$1');
    var sizes = [180, 360, 540, 720, 900];
    var parts = [];
    sizes.forEach(function (w) {
      var sized = clean.indexOf('?') > -1
        ? clean + '&width=' + w
        : clean + '?width=' + w;
      parts.push(sized + ' ' + w + 'w');
    });
    return parts.join(', ');
  }

  /* ---- Helper: build a low-res placeholder URL ---- */
  function buildPlaceholder(baseSrc) {
    var clean = baseSrc.replace(/_\d+x(\.\w+)/, '$1');
    return clean.indexOf('?') > -1
      ? clean + '&width=360'
      : clean + '?width=360';
  }

  /* ---- Product data (parsed once) ---- */
  var productCache = null;
  function readProduct() {
    if (productCache) return productCache;
    var form = document.querySelector('.product-form[data-product-id]');
    var el = form && document.getElementById('ProductJson-' + form.getAttribute('data-product-id'));
    if (!el) return null;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!data.media || !data.variants) return null;

    var mediaById = {}, variantFeaturedIds = {}, shared = [];
    data.media.forEach(function (m) { mediaById[m.id] = m; });
    data.variants.forEach(function (v) {
      if (v.featured_media && v.featured_media.id) variantFeaturedIds[v.featured_media.id] = true;
    });
    /* Shared secondary media (images not assigned as any variant's featured) */
    data.media.forEach(function (m) {
      if (m.media_type !== 'image' || variantFeaturedIds[m.id]) return;
      var srcBase = getMediaSrc(m);
      if (srcBase) shared.push({ id: m.id, thumbSrc: makeThumbSrc(srcBase), alt: m.alt || '' });
    });
    var imagesOnly = data.media.every(function (m) { return m.media_type === 'image'; });
    productCache = { data: data, mediaById: mediaById, shared: shared, imagesOnly: imagesOnly };
    return productCache;
  }

  /* The rail's photos: the variant's featured image, then the shared images,
     MAX_SLIDES in all. The main slideshow holds exactly this list. */
  function railList(variantMedia, sharedSecondary) {
    var list = variantMedia ? [variantMedia] : [];
    return list.concat(sharedSecondary.slice(0, MAX_SLIDES - list.length));
  }

  /* ---- Main image: the theme's slick slideshow, driven by this rail ----
     PMSlider (the "Product Page Slider" app) used to draw the main image. It is
     gone from every live PDP (no pmslider.netlify.app in content_for_header), so
     the theme's slick slideshow is the main image now. Request 214 dropped the
     theme's .thumbnails strip on slider templates, and theme.js moves the
     slideshow to a colour's photo only by triggering 'select' on that strip, so
     nothing moved it: the main image sat on whichever slide of the colour group
     slick landed on (the Gallon's Wizarding Skies showed a hype photo), and a
     rail click swapped the src of a hidden slide. While this rail is the only
     one, the slideshow holds exactly the rail's photos and the rail drives it.
     Templates that keep the theme's strip (hoodie-framework) are left alone. */
  var mainIds = [];

  function mainSlideshow() {
    if (!window.jQuery) return null;
    var $ss = jQuery('#cstm-prdct-glry-imgs .product-slideshow.slick-initialized');
    return $ss.length && $ss[0].slick ? $ss : null;
  }

  /* Images only: the rail has no thumbnails for videos or 3D models, so a
     product with any (the Mystery Crate's video) keeps the theme's slideshow. */
  function railOwnsMain() {
    var g = document.getElementById('cstm-prdct-glry-imgs');
    var p = readProduct();
    return !!(g && p && p.shared.length && p.imagesOnly &&
      !g.querySelector('.thumbnails, .pmslider-slide') && mainSlideshow());
  }

  function markActive(mediaId) {
    document.querySelectorAll('.coldest-secondary-gallery__slide').forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(mediaId));
    });
  }

  /* Show a media id in the main slideshow. Looked up by id among the current
     slides: a filter keeps DOM order and leaves data-slick-index stale. */
  function showMain(mediaId, instant) {
    var $ss = mainSlideshow();
    if (!$ss) return false;
    var at = -1;
    $ss[0].slick.$slides.each(function (i, el) {
      if (el.getAttribute('data-media-id') === String(mediaId)) at = i;
    });
    if (at < 0) return false;
    $ss.slick('slickGoTo', at, !!instant);
    markActive(mediaId);
    return true;
  }

  /* Narrow the slideshow to the rail's photos for this variant, show its image. */
  function syncMain(variantMedia) {
    var p = readProduct();
    if (!p || !railOwnsMain()) return;
    mainIds = railList(variantMedia, p.shared).map(function (m) { return String(m.id); });
    mainSlideshow().slick('slickUnfilter').slick('slickFilter', mainIds.map(function (id) {
      return '.slide[data-media-id="' + id + '"]';
    }).join(','));
    showMain(mainIds[0], true);
  }

  /* theme.js re-filters the slideshow to the colour group in its own handler for
     this event; re-sync once that whole dispatch has finished (before paint). */
  if (window.jQuery) {
    jQuery(document).on('variantImageSelected', '#cstm-prdct-glry-imgs', function (e, variant) {
      var p = readProduct();
      var vm = p && variant && variant.featured_media ? p.mediaById[variant.featured_media.id] : null;
      Promise.resolve().then(function () { syncMain(vm || null); });
    });
  }

  /* For the mobile swipe module below */
  window.__coldestGalleryMain = {
    owns: railOwnsMain,
    ids: function () { return mainIds.slice(); },
    show: showMain
  };

  /* ---- Populate gallery track with variant image + shared secondary images ---- */
  function populateGallery(gallery, variantMedia, sharedSecondary, mediaSrcMap) {
    var track = gallery.querySelector('.coldest-secondary-gallery__track');
    /* Clear existing slides */
    track.innerHTML = '';

    /* Slide 1: variant featured image (starts active); then shared secondary images */
    railList(variantMedia, sharedSecondary).forEach(function (m, i) {
      var slide = m === variantMedia
        ? createSlide(m.id, makeThumbSrc(getMediaSrc(m)), m.alt || '')
        : createSlide(m.id, m.thumbSrc, m.alt);
      if (i === 0) slide.classList.add('is-active');
      track.appendChild(slide);
    });

    /* Re-size and reset slider position */
    if (gallery.__resetSlider) {
      gallery.__resetSlider();
    }
  }

  /* ---- Main init ---- */
  function init() {
    var galleryContainer = document.getElementById('cstm-prdct-glry-imgs');
    if (!galleryContainer) return;

    var galleryInner = galleryContainer.querySelector('.gallery__inner');
    if (!galleryInner) return;

    /* Remove broken gallery from old script version (zero-width slides) */
    var existingGallery = galleryContainer.querySelector('.coldest-secondary-gallery');
    if (existingGallery) {
      var testSlide = existingGallery.querySelector('.coldest-secondary-gallery__slide');
      if (testSlide && testSlide.offsetWidth === 0) {
        existingGallery.remove();
      } else if (existingGallery) {
        return; /* Gallery exists and is working, skip */
      }
    }

    /* Find product data */
    var productForm = document.querySelector('.product-form[data-product-id]');
    if (!productForm) return;
    var product = readProduct();
    if (!product) return;
    var productData = product.data;
    var mediaById = product.mediaById;
    var sharedSecondary = product.shared;

    /* Build full-src lookup for click handler */
    var mediaSrcMap = {};
    productData.media.forEach(function (m) {
      if (m.media_type !== 'image') return;
      var src = getMediaSrc(m);
      if (src) mediaSrcMap[m.id] = src;
    });

    /* Determine current variant's featured media */
    function getCurrentVariantMedia() {
      /* Try to read the selected variant from the URL or form */
      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');

      /* Also check hidden input */
      if (!variantId) {
        var variantInput = productForm.querySelector('input[name="id"], select[name="id"]');
        if (variantInput) variantId = variantInput.value;
      }

      if (variantId) {
        for (var i = 0; i < productData.variants.length; i++) {
          var v = productData.variants[i];
          if (String(v.id) === String(variantId) && v.featured_media) {
            return mediaById[v.featured_media.id] || null;
          }
        }
      }

      /* Fallback: use first variant with a featured media */
      for (var j = 0; j < productData.variants.length; j++) {
        if (productData.variants[j].featured_media) {
          return mediaById[productData.variants[j].featured_media.id] || null;
        }
      }
      return null;
    }

    if (!sharedSecondary.length) return;

    /* Build & insert the gallery shell */
    var secGalleryEl = buildGalleryShell();

    /* Insert AFTER the product slideshow (pmslider-mount) so gallery appears below main image */
    var pmslider = galleryContainer.querySelector(':scope > .pmslider-mount');
    var mainImageEl = galleryInner.querySelector(':scope > .main-image');
    if (pmslider) {
      pmslider.parentNode.insertBefore(secGalleryEl, pmslider.nextSibling);
    } else if (mainImageEl) {
      /* Right under the main image, inside .gallery__inner (where the theme's
         own .thumbnails strip sits): that box is sticky on non-CRO templates,
         and a rail outside it scrolled up over the pinned main image (dog bowl). */
      mainImageEl.parentNode.insertBefore(secGalleryEl, mainImageEl.nextSibling);
    } else {
      galleryContainer.appendChild(secGalleryEl);
    }

    /* Init the slider controls */
    initSlider(secGalleryEl);

    /* Populate with current variant + secondary images */
    var currentVariantMedia = getCurrentVariantMedia();
    populateGallery(secGalleryEl, currentVariantMedia, sharedSecondary, mediaSrcMap);

    /* Main slideshow: sync it if theme.js's first variant event did not, and keep
       the active thumbnail on whatever slide is showing. */
    if (!mainIds.length) syncMain(currentVariantMedia);
    var $main = mainSlideshow();
    if ($main) {
      $main.off('afterChange.cldstRail').on('afterChange.cldstRail', function (e, slick, current) {
        var el = slick.$slides && slick.$slides[current];
        if (el && railOwnsMain()) markActive(el.getAttribute('data-media-id'));
      });
    }

    /* Click handler — show the clicked thumbnail in the main image */
    secGalleryEl.addEventListener('click', function (e) {
      var slide = e.target.closest('.coldest-secondary-gallery__slide');
      if (!slide) return;

      var mediaId = slide.getAttribute('data-media-id');
      if (railOwnsMain() && showMain(mediaId)) return;

      var fullSrc = mediaSrcMap[mediaId];
      if (!fullSrc) return;

      /* Update active state */
      secGalleryEl.querySelectorAll('.coldest-secondary-gallery__slide.is-active')
        .forEach(function (s) { s.classList.remove('is-active'); });
      slide.classList.add('is-active');

      /* Swap the PMSlider main image */
      var pmImg = galleryContainer.querySelector('.pmslider-slide img');
      if (pmImg) {
        pmImg.setAttribute('srcset', buildSrcset(fullSrc));
        pmImg.src = fullSrc;
        pmImg.style.backgroundImage = 'url(' + buildPlaceholder(fullSrc) + ')';
        return;
      }

      /* Fallback: try swapping any main image in the gallery container */
      var mainImg = galleryContainer.querySelector('.main-image img, .gallery__inner img');
      if (mainImg) {
        mainImg.setAttribute('srcset', buildSrcset(fullSrc));
        mainImg.src = fullSrc;
      }
    });

    /* On variant change — swap the first thumbnail to the new variant's featured image */
    function onVariantChange() {
      /* Small delay to let the variant selector update the form value */
      setTimeout(function () {
        var newVariantMedia = getCurrentVariantMedia();
        populateGallery(secGalleryEl, newVariantMedia, sharedSecondary, mediaSrcMap);
      }, 100);
    }

    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('variantImageSelected', '.gallery', onVariantChange);
    }
    document.addEventListener('on:variant:change', onVariantChange);
  }

  /* ---- Bootstrap ---- */
  /* Use 1500ms delay to run AFTER any old script copies (which use 800ms) */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 1500); });
  } else {
    setTimeout(init, 1500);
  }
})();
/* =====================================================================
   Mobile gallery — swipe the main image + "1 / N" counter pill.
   The main image is a slick slideshow with ~all variant images as slides;
   the theme only changes it on variant/thumbnail selection (no swipe). We
   build the "current design's photos" set from the product JSON (the
   selected variant's featured image + the shared, non-variant images) and,
   on a horizontal swipe, swap the SRC of the VISIBLE slide directly. CSS
   hides the pill on desktop and hides the thumbnail strip on mobile.
   ===================================================================== */
(function () {
  var SWIPE_MIN = 40;  /* px horizontal travel to count as a swipe */
  var MAX_PHOTOS = 6;  /* main variant (design) image + 5 shared photos — matches desktop MAX_SLIDES */

  function withWidth(src, w) {
    if (!src) return src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.indexOf('?') > -1 ? src + '&width=' + w : src + '?width=' + w;
  }

  /* Memoized on the <script> element: the ProductJson is 150-300KB and sync()
     polls every 400ms, so re-parsing it each tick cost ~180ms of main thread. */
  var _pdEl = null, _pd = null;
  function getProductData() {
    var form = document.querySelector('.product-form[data-product-id]');
    if (!form) return null;
    var el = document.getElementById('ProductJson-' + form.getAttribute('data-product-id'));
    if (!el) return null;
    if (el === _pdEl && _pd) return _pd;
    try { _pd = JSON.parse(el.textContent); _pdEl = el; return _pd; } catch (e) { return null; }
  }

  function srcOf(m) {
    var s = m && (m.src || (m.preview_image && m.preview_image.src));
    return s ? (s.indexOf('//') === 0 ? 'https:' + s : s) : '';
  }

  /* media-id → full image src, from the product JSON. */
  function mediaSrcById(data) {
    var map = {};
    if (data && data.media) {
      data.media.forEach(function (m) {
        if (m.media_type === 'image') { var s = srcOf(m); if (s) map[String(m.id)] = s; }
      });
    }
    return map;
  }

  /* The mobile swipe set must be IDENTICAL to the desktop gallery. The desktop
     secondary gallery (.coldest-secondary-gallery, built by this same script)
     already holds the curated slides — variant image + the 4 extras — so read
     those exact media-ids and map them to full srcs. Falls back to the same
     variant+shared computation only if that gallery hasn't been built yet. */
  function buildPhotos(data) {
    var map = mediaSrcById(data);
    /* The rail drives the main slideshow: swipe through exactly its photos. */
    var gm = window.__coldestGalleryMain;
    if (gm && gm.owns() && gm.ids().length) {
      return gm.ids().map(function (id) { return map[id]; }).filter(Boolean);
    }
    var sec = document.querySelector('.coldest-secondary-gallery');
    if (sec) {
      var slides = sec.querySelectorAll('.coldest-secondary-gallery__slide');
      if (slides.length) {
        var fromGallery = [];
        Array.prototype.forEach.call(slides, function (sl) {
          var id = sl.getAttribute('data-media-id');
          var full = (id && map[String(id)]) ||
            (((sl.querySelector('img') || {}).src || '')
              .replace(/([?&])width=\d+&height=\d+&crop=center/, '').replace(/[?&]$/, ''));
          if (full) fromGallery.push(full);
        });
        if (fromGallery.length) return fromGallery.slice(0, MAX_PHOTOS);
      }
    }

    /* Fallback (gallery not built yet): variant image first, then shared. */
    if (!data || !data.media || !data.variants) return [];
    var variantFeatured = {};
    data.variants.forEach(function (v) {
      if (v.featured_media && v.featured_media.id) variantFeatured[v.featured_media.id] = true;
    });
    var variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) {
      var inp = document.querySelector('.product-form [name="id"]');
      if (inp) variantId = inp.value;
    }
    var curId = null;
    if (variantId) {
      var vv = data.variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (vv && vv.featured_media) curId = vv.featured_media.id;
    }
    var out = [], seen = {};
    function push(m) {
      if (!m || m.media_type !== 'image') return;
      var s = srcOf(m); if (!s || seen[s]) return;
      seen[s] = 1; out.push(s);
    }
    if (curId) push(data.media.filter(function (m) { return m.id === curId; })[0]);
    data.media.forEach(function (m) { if (!variantFeatured[m.id]) push(m); });
    return out.slice(0, MAX_PHOTOS);
  }

  /* Stop slick from letting the user swipe through all ~58 variant slides —
     only our handler (cycling the curated set) should change the image. */
  function disableSlickSwipe(main) {
    if (!window.jQuery) return;
    try {
      var $ss = jQuery(main).find('.product-slideshow');
      if ($ss.length && $ss.hasClass('slick-initialized')) {
        $ss.slick('slickSetOption', { swipe: false, draggable: false, touchMove: false }, false);
      }
    } catch (e) {}
  }

  function findMain() {
    return document.querySelector('#cstm-prdct-glry-imgs .main-image, .gallery__inner .main-image');
  }

  /* The image element currently on screen — prefer the active slick slide. */
  function visibleImg(main) {
    return main.querySelector('.product-slideshow .slick-current img, .product-slideshow .slick-active img') ||
           main.querySelector('.product-slideshow .slide img') ||
           main.querySelector('img');
  }

  function setup() {
    var main = findMain();
    if (!main) return false;
    var data = getProductData();
    var photos = buildPhotos(data);
    if (photos.length < 1) return false;
    if (main.getAttribute('data-cro-swipe') === '1') return true;
    main.setAttribute('data-cro-swipe', '1');

    var idx = 0;

    var pill = main.querySelector('.cro-gallery-counter');
    if (!pill) {
      pill = document.createElement('div');
      pill.className = 'cro-gallery-counter';
      pill.setAttribute('aria-hidden', 'true');
      main.appendChild(pill);
    }

    function renderCounter() {
      if (photos.length < 2) { pill.style.display = 'none'; return; }
      pill.style.display = '';
      pill.textContent = (idx + 1) + ' / ' + photos.length;
    }

    function show(i) {
      idx = (i + photos.length) % photos.length;
      var gm = window.__coldestGalleryMain;
      if (gm && gm.owns() && gm.show(gm.ids()[idx])) { renderCounter(); return; }
      var img = visibleImg(main);
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.src = withWidth(photos[idx], 900);
        if (img.parentNode && img.parentNode.style) img.parentNode.style.backgroundImage = '';
      }
      renderCounter();
    }

    /* Touch swipe */
    var sx = 0, sy = 0, tracking = false;
    main.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) { tracking = false; return; }
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });

    main.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = (e.changedTouches && e.changedTouches[0]); if (!t) return;
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;
      /* swallow the tap-to-zoom click that may follow a swipe */
      var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); main.removeEventListener('click', swallow, true); };
      main.addEventListener('click', swallow, true);
      setTimeout(function () { main.removeEventListener('click', swallow, true); }, 400);
      show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* Re-read the curated set from the desktop gallery (mirror) + keep slick's
       native swipe disabled. The secondary gallery + slick finish initializing
       after us, so re-sync for a few seconds. */
    function sync(reset) {
      photos = buildPhotos(getProductData());
      disableSlickSwipe(main);
      if (reset) idx = 0;
      if (idx >= photos.length) idx = 0;
      renderCounter();
    }
    sync(false);
    var syncN = 0;
    var syncIv = setInterval(function () { sync(false); if (++syncN > 30) clearInterval(syncIv); }, 400);

    /* Reset to the variant's first photo when the design changes. */
    function onVariant() { setTimeout(function () { sync(true); }, 250); }
    document.addEventListener('on:variant:change', onVariant);
    if (window.jQuery) { try { jQuery(document).on('variantChanged variantImageSelected', '.product-form, .gallery', onVariant); } catch (e) {} }

    renderCounter();
    /* expose for tests */
    main.__croSwipe = { next: function () { show(idx + 1); }, prev: function () { show(idx - 1); }, state: function () { return { idx: idx, total: photos.length }; }, photos: function () { return photos.slice(); } };
    return true;
  }

  function boot() {
    if (setup()) return;
    var n = 0;
    var iv = setInterval(function () { if (setup() || ++n > 60) clearInterval(iv); }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
